import { createReducer, on } from '@ngrx/store';
import { updateTimeseries } from './time-series.actions';
import {
  loadTimeseriesInfoApis,
  loadTimeseriesInfoApisSuccess,
  loadTimeseriesInfoApisFailure,
} from './time-series.actions';

export interface TimeseriesState {
  data: Record<string, any>;
  loading: boolean;
  error?: any;
}

export const initialState: TimeseriesState = {
  data: {},
  loading: false,
};

export const timeseriesReducer = createReducer(
  initialState,
  on(loadTimeseriesInfoApis, (state) => ({ ...state, loading: true })),
  on(loadTimeseriesInfoApisSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    data,
  })),
  on(loadTimeseriesInfoApisFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(updateTimeseries, (state, { list, range, startDate, endDate, chartLabels }) => ({
    ...state,
    data: {
      ...state.data,
      chartData: { list, range, startDate, endDate, chartLabels },
    },
  }))
);
